import { files } from "api/certified-api";
import { certifications } from "api/certified-api";

/**
 * Genera los encabezados para peticiones multipart/form-data con autenticación.
 * @param {string} token - Token JWT.
 * @returns {Object} Headers para subida de archivos.
 */
const getMultipartHeaders = (token) => ({
	'Content-Type': 'multipart/form-data',
	'x-access-token': token
});

/**
 * Sube un archivo con candidatos (formato Excel).
 * @param {FormData} data - Formulario con el archivo.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Respuesta del servidor.
 */
export const uploadCandidates = async (data, token) => {
	const response = await files.post(`/upload/candidates`, data, {
		headers: getMultipartHeaders(token)
	});
	return response.data;
};

/**
 * Sube preguntas de EMeT desde un archivo Excel.
 * @param {FormData} data - Formulario con el archivo.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Respuesta del servidor.
 */
export const uploadEmetQuestion = async (data, token) => {
	const response = await files.post(`/upload/emet/questions`, data, {
		headers: getMultipartHeaders(token)
	});
	return response.data;
};

/**
 * Sube preguntas de EPSt desde un archivo Excel.
 * @param {FormData} data - Formulario con el archivo.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Respuesta del servidor.
 */
export const uploadEpstQuestions = async (data, token) => {
	const response = await files.post(`/upload/epst/questions`, data, {
		headers: getMultipartHeaders(token)
	});
	return response.data;
};

/**
 * Sube un archivo multimedia (audio o imagen) para EPSt.
 * @param {'images' | 'audios'} file_type - Tipo de archivo ('images' o 'audios').
 * @param {FormData} data - Formulario con el archivo.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Respuesta del servidor.
 */
export const uploadEpstMedia = async (file_type, data, token) => {
	const response = await certifications.post(`/upload/epst/${file_type}`, data, {
		headers: getMultipartHeaders(token)
	});
	return response.data;
};

/**
 * Sube un archivo de respuesta de la sección de Speaking para EPSt.
 * @param {FormData} data - Formulario con el archivo de audio.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Respuesta del servidor.
 */
export const uploadEpstSpeaking = async (data, token) => {
	const response = await certifications.post(`/upload/epst/speaking`, data, {
		headers: getMultipartHeaders(token)
	});
	return response.data;
};


